export type ThemeMode = 'light' | 'dark';
export interface ColorTheme {
  primary: {
    main: string;
    hover: string;
    active: string;
  };
  text: {
    primary: string;
    secondary: string;
    disabled: string;
  };
  background: {
    base: string;
    surface: {
      base: string;
      hover: string;
      elevated: string;
      selected: string;
    };
  };
  border: {
    default: string;
    light?: string;
    dark?: string;
  };
  button: {
    default: string;
    hover: string;
    active?: string;
  };
  status: {
    success: string;
    error: string;
    warning?: string;
    info?: string;
  };
}

const darkTheme: ColorTheme = {
  primary: {
    main: '#F5BC6F',
    hover: '#e1a953',
    active: '#c28c46',
  },
  text: {
    primary: '#FFFFFF',
    secondary: '#a3a3a3',
    disabled: '#666666',
  },
  background: {
    base: '#161411',
    surface: {
      base: '#191714',
      hover: '#2A2723',
      elevated: '#322F2C',
      selected: '#21201E',
    },
  },
  border: {
    default: '#322F2C',
  },
  button: {
    default: '#322F2C',
    hover: '#43403C',
  },
  status: {
    success: '#10B981',
    error: '#FF7E68',
  },
};

const lightTheme: ColorTheme = {
  primary: {
    main: '#F5BC6F',
    hover: '#e1a953',
    active: '#c28c46',
  },
  text: {
    primary: '#161411',
    secondary: '#666666',
    disabled: '#a3a3a3',
  },
  background: {
    base: '#FFFFFF',
    surface: {
      base: '#F9F9F9',
      hover: '#F0F0F0',
      elevated: '#F5F5F5',
      selected: '#E8E8E8',
    },
  },
  border: {
    default: '#E0E0E0',
    light: '#F0F0F0',
  },
  button: {
    default: '#F5F5F5',
    hover: '#E8E8E8',
    active: '#E0E0E0',
  },
  status: {
    success: '#10B981',
    error: '#FF7E68',
    warning: '#F59E0B',
    info: '#3B82F6',
  },
};

const themes: Record<ThemeMode, ColorTheme> = {
  dark: darkTheme,
  light: lightTheme,
};

let currentThemeMode: ThemeMode = 'dark';

export const getThemeMode = (): ThemeMode => currentThemeMode;

export const setThemeMode = (mode: ThemeMode): void => {
  currentThemeMode = mode;
};

export const getColors = (): ColorTheme => {
  return themes[currentThemeMode];
};

export const getColorsForMode = (mode: ThemeMode): ColorTheme => {
  return themes[mode];
};

export const colors = getColors();

export type ColorTokens = ColorTheme;

export const isDarkMode = (): boolean => currentThemeMode === 'dark';

export const isLightMode = (): boolean => currentThemeMode === 'light';
